<template>
  <div :id="participantkey + publication[0]" v-on:mousedown="setZindex(participantkey + publication[0])" class="all_video_tracks">
    <span v-show="ready && publication[1].kind == 'video'">{{ participantkey }}</span>
    <!-- <span v-show="ready && screenTrack[0] == publication[0]">{{ 'screen of ' + participantkey }}</span> -->
  </div>
  
</template>

<script>
import interact from "interactjs";

export default {
  name: "Videotrack",
  props: ["participantkey", "publication", "screenTrack", "trackindex"],
  data() {
    return {
      ready: false,
      x: 0,
      y: 0,
      zindex: null
    };
  },
  mounted() {
    let videoruimte = document.getElementById("video_container");
    let videocontainer = document.getElementById(
      this.participantkey + this.publication[0]
    );
    videocontainer.appendChild(this.$props.publication[1].track.attach());
    videocontainer.classList.add("videotrack");
    let i = this.$props.trackindex;
    let videoWidth = 250;
    let margin = 5;
    let areaWidth = videoruimte.offsetWidth;
    let maxRow = Math.floor(areaWidth / videoWidth);
    const height = this.publication[0].height - 10;
    videocontainer.style.height = height;

    if (i > maxRow * 2 - 1 ) {
      videocontainer.style.top = 450 + "px";
      videocontainer.style.left = (((i) - (maxRow * 2)) * 100) + margin + "px";
    } else {
        if (i <= maxRow - 1 ) {
          videocontainer.style.left = ((i) * videoWidth) + margin + "px";
      } else {
        videocontainer.style.top = 225 + "px";
        videocontainer.style.left = ((i - maxRow) * videoWidth) + margin + "px";
      }
    }

    this.enableDragDrop(videocontainer);
    this.ready = true;
    
    // if( this.publication[1].x != undefined){
    //   const startX = this.publication[1].x
    //   const startY = this.publication[1].y

    //   videocontainer.style.transform = `translate(${startX}px,${startY}px)`;

    //   this.x = startX
    //   this.y = startY

    //   const width = this.publication[1].width
    //   const height = this.publication[1].height
    //   if(width != undefined){
    //     videocontainer.style.width = width;
    //     videocontainer.style.height = height;
    //   }
    // }

  },

  methods: {
    setZindex(elem) {
      let styleobject = document.getElementById(elem);
      let otherobjects = document.getElementsByClassName("all_video_tracks");
      otherobjects.forEach(function(track, i){
        track.style.zIndex = "100";
      });
      styleobject.style.zIndex = "1000";
    },
    
    enableDragDrop(container) {
      const VueThis = this;
      interact(container)
        .resizable({
          // resize from all edges and corners
          edges: { left: false, right: true, bottom: true, top: false },

          listeners: {
            move(event) {
              var target = event.target;
              let x = parseFloat(target.getAttribute("data-x")) || 0;
              let y = parseFloat(target.getAttribute("data-y")) || 0;

              // update the element's style
              target.style.width = event.rect.width + "px";
              target.style.height = event.rect.height + "px";

              // translate when resizing from top or left edges
              x += event.deltaRect.left;
              y += event.deltaRect.top;

              target.style.webkitTransform = target.style.transform =
                "translate(" + VueThis.x + "px," + VueThis.y + "px)";

              target.setAttribute("data-x", VueThis.x);
              target.setAttribute("data-y", VueThis.y);
            }
          },
          modifiers: [
            // keep the edges inside the parent
            interact.modifiers.restrictEdges({
              outer: document.getElementById("app")
            }),

            // minimum size
            interact.modifiers.restrictSize({
              min: { width: 100, height: 50 }
            }),

            interact.modifiers.aspectRatio({
              ratio: "preserve"
            }),
          ],
          inertia: true
        })
        .draggable({
          modifiers: [
            interact.modifiers.snap({
              targets: [interact.createSnapGrid({ x: 30, y: 30 })],
              range: Infinity,
              relativePoints: [{ x: 0, y: 0 }]
            }),
            interact.modifiers.restrict({
              restriction: document.getElementById("app"),
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
              // endOnly: true
            })
          ],
          inertia: true
        })
        .on("dragmove", function(event) {
          VueThis.x += event.dx;
          VueThis.y += event.dy;

          event.target.style.webkitTransform = event.target.style.transform =
            "translate(" + VueThis.x + "px, " + VueThis.y + "px)";
        });
    }
  }
}
</script>

<style lang="css" scoped>
.videotrack {
  margin:10px;
  background-color:#dbfcf0;
  filter: drop-shadow(0 0 0.3rem rgba(0, 0, 0, 0.733));
  z-index:10;
  /* fix for the small border on the bottom */
  font-size: 0;
}

.videotrack >>> video {
  width:100%;
  height:auto;
  object-fit: cover;
}

span {
  position:absolute;
  color: black;
  background-color:#dbfcf0;
  top:-30px;
  text-align: center;
  width:100%;
  z-index: 500;
  font-size:16px;
  line-height:30px;
} 
</style>
